import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient';
import { BaseResponse } from '../UtilsInterface';
import {
  NotificationsData,
  NotificationsListApiResponse,
} from './NotificationInterfaces';

// 사용자 알림 관련 서비스 정의
const NotificationService = {
  // 알림 목록 조회
  getNotificationsList: async (
    page: number,
    size: number
  ): Promise<NotificationsListApiResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_notification_list(page, size)
      );
      return response.data;
    } catch (error) {
      console.error('알림 목록 조회 실패:', error);
      throw error;
    }
  },

  // 알림 상세 조회
  getNotificationDetail: async (
    notificationId: string
  ): Promise<BaseResponse<NotificationsData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_notification_detail(notificationId)
      );
      return response.data;
    } catch (error) {
      console.error('알림 상세 조회 실패:', error);
      throw error;
    }
  },

  // 알림 삭제
  deleteNotification: async (
    notificationId: string
  ): Promise<BaseResponse<void>> => {
    try {
      const response = await apiClient.delete(
        API_ENDPOINTS.delete_notification(notificationId)
      );
      return response.data; // 반환 값 명시
    } catch (error) {
      console.error('알림 삭제 실패:', error);
      throw error;
    }
  },

  // 읽지 않은 알림 개수 조회
  getUnreadNotificationsCount: async (): Promise<BaseResponse<number>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_unread_notification_count()
      );
      return response.data;
    } catch (error) {
      console.error('읽지 않은 알림 개수 조회 실패:', error);
      throw error;
    }
  },
};

export default NotificationService;
